import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectCourse } from "../slices/trainer";
import { H2 } from "./H2";
import { P } from "./P";
import { Button } from "./Button";
import { PageLayout } from "./PageLayout";

export function PageCourseNotReady() {
  const dispatch = useDispatch();
  const course = useSelector((state) => state.trainer.course);
  const courseName = course?.Course?.Name || "This course";
  const vortexRef = course?.VortexRef;

  return (
    <PageLayout>
      <div className="flex flex-col gap-4">
        <H2>Course not ready</H2>
        <P>
          {courseName}
          {vortexRef ? ` (${vortexRef})` : ""} hasn't been fully prepared yet,
          so we can't start it here.
        </P>
        <P>
          Please contact the office to finish booking setup, then come back and
          reopen this course.
        </P>
        <div className="text-right">
          <Button variant="cta" onClick={() => dispatch(selectCourse(null))}>
            Back to course list
          </Button>
        </div>
      </div>
    </PageLayout>
  );
}
